import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {

  //params: riderDetails
  addLifeRider({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.addLifeRider(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  //params: riderID
  removeLifeRider({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.removeLifeRider(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  //params: entireNewLife fields
  transferInLife({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.transferInLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  // params: ID, files, attachment
  transferOutLife({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.transferOutLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  // params: ID, files, attachment
  coolingOff({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.coolingOff(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },


  // params: ID, premiumType, files, attachment
  changePremiumTypeLife({ state }, params, success, error) {
    return new Promise((resolve, reject) => {
      api.changePremiumTypeLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },



  // params: ID, policyLapseDate
  lapseLife({ state }, params) {
    return new Promise((resolve, reject) => {
      api.lapseLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },

  // params: ID, policyEndDate, files, attachment
  surrenderLife({ state }, params) {
    return new Promise((resolve, reject) => {
      api.surrenderLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },

  // params: ID, policyReinstateDate
  reinstateLife({ state }, params) {
    return new Promise((resolve, reject) => {
      api.reinstateLife(params, (json) => {
        switch (json.status) {
          case 200:
            resolve();
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err)
      })
    })
  },



  getLifeDetail({ state, commit, dispatch }, isConcat = false) {

    return new Promise((resolve, reject) => {
      api.getLifeDetail(state.newLife.policyID, isConcat, (json) => {
        switch (json.status) {
          case 200:
            console.debug(json);
            dispatch('setAllLifeInfo', json.data);
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }

      }, (error) => {
        console.log(error);
        reject(error);
      })
    })
  },

  // searchLifeList({ state }, searchValue) {
  //   return new Promise((resolve, reject) => {
  //     api.searchLifeList(searchValue, (json) => {
  //       resolve(json);
  //     }, (error) => {
  //       reject(error);
  //     })
  //   })
  // },

  // params : count, page, workflowStep, status, type
  getLifeList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getLifeList(params, (json) => {
        resolve(json.data);
      }, (error) => {
        reject(error);
      })
    })
  },

  setWorkflowCurrentStep({ commit, state }, currentStep) {
    console.log(currentStep);
    commit({ type: 'setWorkflowCurrentStep', currentStep: currentStep })
    var currentStepRequirements = state.newLife.workflowStepRequirement['step' + (currentStep + 1)];
    console.log(currentStepRequirements);
    currentStepRequirements.forEach((item) => {
      commit({
        type: 'setCurrentStepFieldStatus',
        name: item.name,
        disabled: item.status.disabled,
        hide: item.status.hide
      });
    })
  },

  createLifePolicy({ commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.createLifePolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              console.log(json);
              dispatch('setWorkflowCurrentStep', 1);
              commit({ type: 'setLifePolicyID', policyID: json.data.ID });
              commit({ type: 'setLifePaymentMethodID', paymentMethodID: json.data.paymentMethodID });
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              resolve();
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  confirmLifePolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.confirmLifePolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 1);
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 2);
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
          resolve();
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  sendOutLifePolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.sendOutLifePolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 2)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 3)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  saveLifePolicy({ commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.saveLifePolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  rejectLifePolicy({ commit, dispatch }, policyID) {
    return new Promise((resolve, reject) => {
      api.rejectLifePolicy(policyID, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              // dispatch('setWorkflowCurrentStep', 5)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  inforceLifePolicy({ commit, dispatch }, policyDetails) {
    return new Promise((resolve, reject) => {
      api.inforceLifePolicy(policyDetails, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              dispatch('setWorkflowCurrentStep', 6)
              commit({ type: 'setLifeApproveAgent', approveAgent: json.data.serviceAgentAgentID });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  deleteLifePolicy({ commit, dispatch }, policyID) {
    return new Promise((resolve, reject) => {
      api.deleteLifePolicy(policyID, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  companyReceiveLifePolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.companyReceiveLifePolicy(payload.form, (json) => {
          switch (json.status) {

            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 6)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 7)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  agentReceiveLifePolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.agentReceiveLifePolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              if (payload.isToPrev) {
                dispatch('setWorkflowCurrentStep', 7)
                resolve(json);
                break;
              }
              dispatch('setWorkflowCurrentStep', 8)
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  customerReceiveLifePolicy({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      api.customerReceiveLifePolicy(payload.form, (json) => {
          switch (json.status) {
            case 200:
              commit({ type: 'setPolicyAgent', policyAgent: json.data.policyAgent });
              // if (payload.isToPrev) {
              //   dispatch('setWorkflowCurrentStep', 8)
              //   resolve(json);
              //   break;
              // }
              resolve(json);
              // dispatch('setWorkflowCurrentStep', 9)
              break;
            default:
              reject(json);
              break;
          }

        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },

  setAllLifeInfo({ commit }, lifeObj) {
    commit({ type: 'setLifeGeneralInfo', lifeGeneralInfo: lifeObj });
    commit({ type: 'setLifePolicyID', policyID: lifeObj.ID });
    commit({ type: 'setLifePaymentMethodID', paymentMethodID: lifeObj.paymentMethodID })
  },

  resetNewLifeState({ commit, dispatch }) {
    dispatch('setLifeGeneralInfoInitState');
    commit({ type: 'setIsRejected', value: false });
    commit({ type: 'setIsCompleted', value: false });
    dispatch('setWorkflowCurrentStep', 0);
  },

  setLifeGeneralInfoInitState({ commit }) {
    var lifeGeneralInfo = {
      productID: -1,
      policyNumber: '',
      policyReference: '',
      applicationDate: '',
      applicationReceivedDate: '',
      conditionalAssignmentFlag: 'Y',
      policyCurrency: 'HKD',
      originalReferrer: -1,
      // originalAgent: -1,
      // currentAgent: -1,
      lastPaymentDate: '',
      approveAgent: -1,
      policyTerm: 0,
      beneficiary: '',
      thirdParty: '',
      policyOwner: -1,
      insurer: -1,
      policyAgentChangeReason: '',
      // policyFee: 0,
      docs: {},
      attachment: [],
      totalSinglePremiumPaid: 0,
      totalRegularPremiumPaid: 0,
      premiumType: 'A',
      levy: 0,
      policyAgent: [{
        agentID: -1,
        agentSplitRate: '',
        isActive: "Y",
        isServiceAgent: "Y",
        effectiveDate: '',
        expiryDate: ''
      }],
      // Model Premiums
      totalPremiums: 0,
      paymentMethod: "",
      // companyBank: "BOC",
      // paymentReference: "xxxxxxxx",
      // paymentDate: "2018-06-10",
      // paymentAmount: 0,
      // premiumAmount: 0,
      remarks: '',
      // premiumPaid: 0,
      sentOutDate: '',
      sentOutMedium: '',
      sentOutReference: '',
      commencementDate: '',
      issueDate: '',
      companyReceiveDate: '',
      agentReceiveDate: '',
      customerReceiveDate: '',
      version: 1,
    }
    commit({ type: 'setLifeGeneralInfo', lifeGeneralInfo: lifeGeneralInfo })
  },

  // addLifeRider({ state }, params, success, error) {
  //   return new Promise((resolve, reject) => {
  //     api.addLifeRider(params, (json) => {
  //       switch (json.status) {
  //         case 200:
  //           resolve();
  //           break;
  //         default:
  //           reject(json);
  //           break;
  //       }
  //     }, (err) => {
  //       reject(err);
  //     })
  //   })
  // },

  // //params: riderID
  // removeLifeRider({ state }, params, success, error) {
  //   return new Promise((resolve, reject) => {
  //     api.removeLifeRider(params, (json) => {
  //       switch (json.status) {
  //         case 200:
  //           resolve(json.data);
  //           break;
  //         default:
  //           reject(json);
  //           break;
  //       }
  //     }, (err) => {
  //       reject(err);
  //     })
  //   })
  // },

  editPolicyAgent({ commit, dispatch }, form) {
    return new Promise((resolve, reject) => {
      api.editPolicyAgent(form, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (error) => {
          reject(error);
          console.error(error);
        })
    })
  },
}



// WEBPACK FOOTER //
// ./src/Osm/LifePolicy/store/actions.js